import React from 'react';
import { Tooltip } from 'antd';
import { checkActionAllowed, isValidArray, isValidArrayWithValues } from '../../utils/utilities';
import { TOOLTIP_HIDE_BOOK_INFO_OTHER_USER, getSameUser } from '../../utils/constant';
import { extractPassengerInfo, getTicketInfoInfo, TooltipContent } from './common-seat-layout';


export const getPassengerList=(seat,passengers)=>{
    let passengersList=[];
    
    if(isValidArray(passengers)){
        let hideToolTip = checkActionAllowed(TOOLTIP_HIDE_BOOK_INFO_OTHER_USER);
        let displayStatus = seat.seat_status == "Blocked" ? "Blocked" : "Booked";
            passengers.forEach((element,index) => {
                if (hideToolTip){
                    if (getSameUser(element.agent_id)){
                        let toolTipContent = extractPassengerInfo(element, displayStatus);
                        passengersList.push(
                            <TooltipContent {...toolTipContent} passengerNo={passengers.length > 1?`Passenger ${index+1}`:null} />
                        )
                    }
                }
                else {
                    let toolTipContent = extractPassengerInfo(element, displayStatus);
                    passengersList.push(
                        <TooltipContent {...toolTipContent} passengerNo={passengers.length > 1?`Passenger ${index+1}`:null} />
                    )            
                }
            });   
    }else{
        let toolTipContent = getTicketInfoInfo(seat, seat.passengers, seat.seat_status == "Blocked" ? "Blocked" : "Booked");                
        passengersList.push(
            <TooltipContent {...toolTipContent} passengerNo={null} />
        )
    }
    return passengersList;
}

export const  ShowMultiplePassengers =(props)=> {

    const{
        seat
    } = props;

    let passengers = seat.passengers;

    if(passengers.length == 0){
        return null
    }
    
    let toolTipInfo = <div className={'passengerCountBlock'}>
                        <div className='passengerCount'>{passengers.length}</div>
                    </div>;


    if (isValidArrayWithValues(passengers)){
        return (
            <div className={'passengerCountBlock'}>
                        <div className='passengerCount'>{passengers.length}</div>
            </div>
        );
    }
    else {
        return toolTipInfo;
    }
}